
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC"}},[_c('path',{attrs:{"d":"M24 25a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1z"}}),_c('path',{attrs:{"d":"M33 9.5H6V40h20V22a2 2 0 0 1 2-2h5z"}})]),_c('path',{staticClass:"i-Rectangle 14",attrs:{"stroke":"#234652","d":"M35 16V7a3 3 0 0 0-3-3H11a3 3 0 0 0-3 3v32a3 3 0 0 0 3 3h13"}}),_c('rect',{staticClass:"i-Rectangle 15",attrs:{"width":"13","height":"25","x":"26.5","y":"18.5","stroke":"#234652","rx":"1.5"}}),_c('path',{staticClass:"i-Line 16",attrs:{"stroke":"#234652","d":"M31 21.5h4"}}),_c('path',{staticClass:"i-Line 17",attrs:{"stroke":"#234652","d":"M8 38.5h16"}}),_c('path',{staticClass:"i-Line 19",attrs:{"stroke":"#234652","d":"M8 7.5h27"}})])
          )
        }
      }
    